import { Card, Form, Button, Row, Col } from "react-bootstrap";
import {
  FaUserPlus,
  FaSave,
  FaTimes,
  FaCheckSquare,
  FaPhoneAlt,
} from "react-icons/fa";

function CustomerForm({
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  plan,
  setPlan,
  status,
  setStatus,
  expiryDate,
  setExpiryDate,
  callAccess,
  setCallAccess,
  addCustomer,
  updateCustomer,
  clearForm,
  editingCustomerId,
}) {
  const accessOptions = ["Long Term", "Mid Term", "Short Term"];

  const formatPhone = (value) => {
    let cleaned = value.replace(/\s/g, "");

    if (!cleaned.startsWith("+91")) {
      cleaned = "+91" + cleaned.replace("+91", "");
    }

    return cleaned;
  };

  const toggleCallAccess = (type) => {
    if (callAccess.includes(type)) {
      setCallAccess(callAccess.filter((item) => item !== type));
    } else {
      setCallAccess([...callAccess, type]);
    }
  };

  return (
    <Card className="shadow border-0 mb-4">
      <Card.Body>
        <h4 className="mb-4">
          {editingCustomerId ? (
            <>
              <FaSave className="me-2 text-warning" />
              Edit Customer
            </>
          ) : (
            <>
              <FaUserPlus className="me-2 text-success" />
              Add New Customer
            </>
          )}
        </h4>

        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Customer Name</Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter customer name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>

              <Form.Control
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <small className="text-muted">
                Email will be used as the secure customer document ID.
              </small>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaPhoneAlt className="me-2 text-success" />
                Mobile Number
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="+919353219987"
                value={phone}
                onChange={(e) => setPhone(formatPhone(e.target.value))}
              />

              <small className="text-muted">
                Use format: +91XXXXXXXXXX
              </small>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Subscription Plan</Form.Label>

              <Form.Select
                value={plan}
                onChange={(e) => setPlan(e.target.value)}
              >
                <option>1 Month</option>
                <option>3 Month</option>
                <option>6 Month</option>
                <option>1 Year</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>

              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>Active</option>
                <option>Expired</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Expiry Date</Form.Label>

              <Form.Control
                type="date"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e.target.value)}
              />

              <small className="text-muted">
                Leave blank while adding customer to auto-calculate from plan.
              </small>
            </Form.Group>
          </Col>
        </Row>

        <Card className="border-0 bg-light mb-4">
          <Card.Body>
            <h6 className="fw-bold mb-3">
              <FaCheckSquare className="me-2 text-success" />
              Call Access
            </h6>

            <Row>
              {accessOptions.map((type) => (
                <Col md={4} key={type} className="mb-2">
                  <Form.Check
                    type="checkbox"
                    label={type}
                    checked={callAccess.includes(type)}
                    onChange={() => toggleCallAccess(type)}
                  />
                </Col>
              ))}
            </Row>

            <small className="text-muted">
              Select the call categories this customer has paid for.
            </small>
          </Card.Body>
        </Card>

        {editingCustomerId ? (
          <Row>
            <Col md={6} className="mb-2">
              <Button
                variant="secondary"
                className="w-100"
                onClick={clearForm}
              >
                <FaTimes className="me-2" />
                Cancel Edit
              </Button>
            </Col>

            <Col md={6} className="mb-2">
              <Button
                variant="warning"
                className="w-100"
                onClick={updateCustomer}
              >
                <FaSave className="me-2" />
                Update Customer
              </Button>
            </Col>
          </Row>
        ) : (
          <Button variant="success" onClick={addCustomer}>
            <FaUserPlus className="me-2" />
            Add Customer
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default CustomerForm;